export interface Movie {
  id: string;
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  rating: number;
  year: number;
  image: string;
  description: string;
  fullDescription: string;
  director: string;
  actors: string[];
  duration: string;
  type: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export interface MovieCategory {
  name: string;
  slug: string;
  icon: string;
}

export const categories: MovieCategory[] = [
  { name: '全部', slug: 'all', icon: 'ri-film-line' },
  { name: '动作片', slug: 'dongzuo', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'xiju', icon: 'ri-emotion-happy-line' },
  { name: '爱情片', slug: 'aiqing', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'kehuan', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'kongbu', icon: 'ri-ghost-line' },
  { name: '动画片', slug: 'donghua', icon: 'ri-palette-line' },
  { name: '纪录片', slug: 'jilupian', icon: 'ri-camera-line' },
  { name: '剧情片', slug: 'juqing', icon: 'ri-clapperboard-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    slug: 'xiao-shen-ke-de-jiu-shu',
    title: '肖申克的救赎',
    category: '剧情片',
    categorySlug: 'juqing',
    rating: 9.7,
    year: 1994,
    image: 'https://readdy.ai/api/search-image?query=Shawshank%20Redemption%20movie%20poster%20style%2C%20dramatic%20cinematic%20lighting%2C%20prison%20scene%20with%20hope%20theme%2C%20warm%20golden%20tones%2C%20rain%20silhouette%20moment%2C%20classic%20film%20aesthetic%2C%20minimalist%20poster%20design%2C%20clean%20background&width=800&height=1200&seq=movie-shawshank&orientation=portrait',
    description: '一个银行家被冤枉入狱，在肖申克监狱中历经磨难，凭借智慧与毅力最终获得自由，诠释了希望与救赎的力量。',
    fullDescription: '《肖申克的救赎》是弗兰克·德拉邦特执导的经典剧情片，改编自斯蒂芬·金的中篇小说。影片讲述了银行家安迪·杜佛兰因被误判谋杀妻子及其情人而被判终身监禁，关进肖申克监狱。在狱中，他凭借自身的金融专业知识为狱警和典狱长处理税务，同时默默计划着越狱。他与狱友瑞德建立了深厚的友谊，用二十年的时间凿开了一条通往自由的隧道。影片通过安迪的故事深刻探讨了希望、自由、友谊和救赎等永恒主题，被誉为影史最伟大的电影之一，在IMDb和豆瓣等平台长期位居评分榜首。',
    director: '弗兰克·德拉邦特',
    actors: ['蒂姆·罗宾斯', '摩根·弗里曼', '鲍勃·冈顿'],
    duration: '142分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['经典', '励志', '剧情'],
  },
  {
    id: '2',
    slug: 'ba-wang-bie-ji',
    title: '霸王别姬',
    category: '剧情片',
    categorySlug: 'juqing',
    rating: 9.6,
    year: 1993,
    image: 'https://readdy.ai/api/search-image?query=Farewell%20My%20Concubine%20Chinese%20movie%20poster%20style%2C%20Peking%20opera%20aesthetic%2C%20dramatic%20stage%20lighting%2C%20traditional%20Chinese%20costume%2C%20golden%20and%20red%20tones%2C%20artistic%20film%20poster%20design%2C%20clean%20simple%20background&width=800&height=1200&seq=movie-farewell-concubine&orientation=portrait',
    description: '两个京剧伶人半个世纪的悲欢离合，折射出中国社会的巨大变迁，一曲戏梦人生的绝唱。',
    fullDescription: '《霸王别姬》由陈凯歌执导，张国荣、张丰毅、巩俐主演。影片横跨半个世纪，讲述了京剧演员程蝶衣和段小楼之间复杂的情感纠葛。程蝶衣自幼被送入戏班，与师兄段小楼一同成长为京城名角，两人合演的《霸王别姬》誉满京城。然而时代变迁，从民国到抗日战争，从解放到文化大革命，两人的命运在历史洪流中跌宕起伏。程蝶衣将对艺术和师兄的执念融入生命，最终在舞台上以虞姬的身份结束了自己的一生。影片以其宏大的历史视野、深刻的艺术表达和震撼的表演被誉为华语电影的巅峰之作。',
    director: '陈凯歌',
    actors: ['张国荣', '张丰毅', '巩俐'],
    duration: '171分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['经典', '文艺', '历史'],
  },
  {
    id: '3',
    slug: 'dao-meng-kong-jian',
    title: '盗梦空间',
    category: '科幻片',
    categorySlug: 'kehuan',
    rating: 9.3,
    year: 2010,
    image: 'https://readdy.ai/api/search-image?query=Inception%20movie%20poster%20style%2C%20surreal%20dream%20landscape%2C%20city%20folding%20visual%20effect%2C%20mysterious%20atmosphere%2C%20dark%20blue%20and%20silver%20tones%2C%20cinematic%20sci-fi%20aesthetic%2C%20minimalist%20poster%20design&width=800&height=1200&seq=movie-inception&orientation=portrait',
    description: '诺兰打造的梦境奇观，层层嵌套的梦中世界，烧脑的叙事结构带来前所未有的观影体验。',
    fullDescription: '《盗梦空间》是克里斯托弗·诺兰执导的科幻动作片。影片讲述了一个特殊的盗贼团队，他们能够进入人们的梦境中窃取潜意识中的秘密。主角柯布是一个技艺高超的"盗梦者"，因为被指控谋杀妻子而流亡海外。为了能够回到孩子们的身边，他接下了看似不可能完成的任务——不是窃取想法，而是在目标的潜意识中植入一个想法，即"奠基"。团队构建了多层梦境，在层层嵌套的梦境中展开惊心动魄的行动。影片以其独特的叙事结构、令人叹为观止的视觉效果和深刻的哲学思考，成为科幻电影史上的里程碑之作。',
    director: '克里斯托弗·诺兰',
    actors: ['莱昂纳多·迪卡普里奥', '约瑟夫·高登-莱维特', '艾伦·佩吉'],
    duration: '148分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['科幻', '烧脑', '悬疑'],
  },
  {
    id: '4',
    slug: 'san-ti',
    title: '三体',
    category: '科幻片',
    categorySlug: 'kehuan',
    rating: 9.0,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=Three%20Body%20Problem%20sci-fi%20poster%20style%2C%20cosmic%20mystery%2C%20three%20suns%20in%20alien%20sky%2C%20futuristic%20technology%2C%20deep%20space%20atmosphere%2C%20mysterious%20dark%20tone%2C%20cinematic%20poster%20design%2C%20clean%20background&width=800&height=1200&seq=movie-three-body&orientation=portrait',
    description: '根据刘慈欣雨果奖获奖小说改编，人类文明与三体文明的首次接触，开启了一场跨越光年的宇宙博弈。',
    fullDescription: '《三体》改编自刘慈欣的同名科幻巨著，是中国科幻影视的里程碑作品。故事始于文化大革命期间，天体物理学家叶文洁在红岸基地向宇宙发出了人类的第一声啼鸣。四光年外的三体文明在收到信息后，开始了向地球的远征。与此同时，地球上的基础科学开始出现异常，纳米科学家汪淼卷入了一场关于"科学边界"的神秘调查。随着真相逐渐浮出水面，人类意识到自己正面临前所未有的生存危机。三体人的智子已经到达地球，锁死了人类的基础科学研究，一场关乎文明存亡的战争悄然拉开序幕。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '王子文'],
    duration: '30集',
    type: 'series',
    isHot: true,
    isNew: true,
    tags: ['科幻', '国产', '热门'],
  },
  {
    id: '5',
    slug: 'kuang-biao',
    title: '狂飙',
    category: '剧情片',
    categorySlug: 'juqing',
    rating: 9.1,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=The%20Knockout%20Chinese%20crime%20drama%20poster%2C%20police%20versus%20gangster%20theme%2C%20intense%20dramatic%20atmosphere%2C%20dark%20urban%20setting%2C%20golden%20and%20shadow%20lighting%2C%20crime%20thriller%20aesthetic%2C%20clean%20minimalist%20poster&width=800&height=1200&seq=movie-the-knockout&orientation=portrait',
    description: '一部横跨二十年的扫黑题材剧集，展现警察与黑恶势力之间的正邪较量，演技炸裂口碑爆棚。',
    fullDescription: '《狂飙》是2023年开年爆款剧集，由徐纪周执导，张译、张颂文主演。故事横跨二十年，讲述了刑警安欣与鱼贩出身的高启强之间长达一生的正邪较量。高启强从一个受人欺负的鱼贩逐步蜕变为京海市最大的黑恶势力头目，而安欣则始终坚守正义一线，在漫长的岁月中与黑恶势力展开殊死搏斗。剧集通过丰富的群像塑造，深刻展现了社会变迁中的人性抉择，被誉为近年来最优秀的国产电视剧之一。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    duration: '39集',
    type: 'series',
    isHot: true,
    isNew: false,
    tags: ['扫黑', '剧情', '热门'],
  },
  {
    id: '6',
    slug: 'ni-hao-li-huan-ying',
    title: '你好，李焕英',
    category: '喜剧片',
    categorySlug: 'xiju',
    rating: 8.8,
    year: 2021,
    image: 'https://readdy.ai/api/search-image?query=Hi%20Mom%20Chinese%20comedy%20movie%20poster%2C%20mother%20daughter%20warm%20relationship%2C%20nostalgic%201980s%20China%20setting%2C%20warm%20golden%20lighting%2C%20heartwarming%20atmosphere%2C%20vintage%20Chinese%20aesthetic%2C%20clean%20poster%20design&width=800&height=1200&seq=movie-hi-mom&orientation=portrait',
    description: '贾玲导演处女作，穿越时空回到母亲年轻时代，笑中带泪的温暖故事，中国影史票房奇迹。',
    fullDescription: '《你好，李焕英》是贾玲执导并主演的喜剧电影，改编自她的同名小品。影片讲述了2001年，刚考上大学的贾晓玲意外穿越到1981年，与年轻时的母亲李焕英相遇。为了让母亲过上更好的生活，贾晓玲想方设法帮助母亲改变命运，却在这一过程中逐渐理解了母亲深沉的爱。影片巧妙地将喜剧元素与亲情主题相结合，前半段笑点密集，后半段催人泪下，以真挚的情感打动了无数观众，创造了中国影史票房奇迹。',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾'],
    duration: '128分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['喜剧', '亲情', '温情'],
  },
  {
    id: '7',
    slug: 'liu-lang-di-qiu-2',
    title: '流浪地球2',
    category: '科幻片',
    categorySlug: 'kehuan',
    rating: 8.6,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%202%20sci-fi%20movie%20poster%2C%20massive%20space%20station%2C%20Earth%20engines%2C%20cosmic%20scale%20visual%2C%20futuristic%20Chinese%20sci-fi%2C%20epic%20cinematic%20lighting%2C%20cool%20blue%20tones%2C%20clean%20poster%20design&width=800&height=1200&seq=movie-wandering-earth-2&orientation=portrait',
    description: '前传故事揭示"流浪地球计划"的起源，人类面临太阳危机时的艰难抉择，中国科幻的又一力作。',
    fullDescription: '《流浪地球2》是郭帆执导的科幻史诗，作为《流浪地球》的前传，讲述了"流浪地球计划"提出和实施的初期阶段。面对太阳急速老化膨胀、百年内将吞噬整个太阳系的危机，人类提出了"移山计划"（后更名为"流浪地球计划"），即在全球建造上万座行星发动机推动地球离开太阳系。影片通过多条故事线交错叙事，展现了数字生命派与移山派的理念之争、太空电梯危机、月球坠落危机等重大事件，以宏大的格局和精良的制作重新定义了中国科幻电影的高度。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    duration: '173分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['科幻', '国产', '视觉'],
  },
  {
    id: '8',
    slug: 'gui-mie-zhi-ren',
    title: '鬼灭之刃',
    category: '动画片',
    categorySlug: 'donghua',
    rating: 9.2,
    year: 2019,
    image: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%20style%2C%20Japanese%20animation%20aesthetic%2C%20sword%20fighting%20scene%2C%20traditional%20Japanese%20elements%2C%20vibrant%20water%20breathing%20effect%2C%20dynamic%20action%20pose%2C%20colorful%20art%20style%2C%20clean%20background&width=800&height=1200&seq=movie-demon-slayer&orientation=portrait',
    description: '现象级日本动画，少年炭治郎为救妹妹踏上斩鬼之路，华丽的战斗画面和感人故事征服全球观众。',
    fullDescription: '《鬼灭之刃》改编自吾峠呼世晴创作的同名漫画，由ufotable制作动画。故事发生在大正时期的日本，主角灶门炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复为人类的方法，炭治郎加入了鬼杀队，踏上了斩鬼之旅。一路上他结识了善逸、伊之助等伙伴，共同对抗以鬼舞辻无惨为首的鬼族势力。动画以其精美的作画、华丽的战斗场面和感人至深的人物故事赢得了全球观众的喜爱，剧场版《无限列车篇》更是刷新了日本影史票房纪录。',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    duration: '63集',
    type: 'series',
    isHot: true,
    isNew: false,
    tags: ['日漫', '热血', '战斗'],
  },
  {
    id: '9',
    slug: 'tai-tan-ni-ke-hao',
    title: '泰坦尼克号',
    category: '爱情片',
    categorySlug: 'aiqing',
    rating: 9.4,
    year: 1997,
    image: 'https://readdy.ai/api/search-image?query=Titanic%20movie%20romantic%20poster%2C%20couple%20on%20ship%20bow%2C%20sunset%20golden%20lighting%2C%20grand%20ocean%20liner%2C%20classic%20romance%20film%20aesthetic%2C%20dramatic%20cinematic%20atmosphere%2C%20warm%20golden%20tones%2C%20clean%20minimalist%20poster&width=800&height=1200&seq=movie-titanic&orientation=portrait',
    description: '永不沉没的爱情传奇，杰克与露丝在巨轮上的浪漫邂逅，感动了全世界几代观众。',
    fullDescription: '《泰坦尼克号》是詹姆斯·卡梅隆执导的史诗爱情灾难片。影片以1912年泰坦尼克号首航为背景，讲述了出身贫寒的画家杰克和贵族少女露丝在巨轮上相遇相爱的故事。两人跨越阶级的隔阂坠入爱河，然而巨轮撞上冰山即将沉没，他们的爱情面临生死考验。在灾难面前，杰克将生存的机会留给了露丝，自己永远沉入了冰冷的大西洋。影片以老年露丝的回忆为框架，细腻而宏大地再现了这段跨越八十多年的深情记忆。影片曾获得11项奥斯卡金像奖，是全球影史票房最高的电影之一。',
    director: '詹姆斯·卡梅隆',
    actors: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特'],
    duration: '194分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['爱情', '经典', '灾难'],
  },
  {
    id: '10',
    slug: 'zhou-chu-chu-san-hai',
    title: '周处除三害',
    category: '动作片',
    categorySlug: 'dongzuo',
    rating: 8.5,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=The%20Pig%20the%20Snake%20and%20the%20Pigeon%20Taiwan%20action%20movie%20poster%2C%20intense%20gangster%20theme%2C%20dark%20criminal%20underworld%2C%20stylish%20action%20cinematography%2C%20neon%20lighting%2C%20gritty%20atmosphere%2C%20modern%20Asian%20cinema%2C%20clean%20poster&width=800&height=1200&seq=movie-the-pig-snake-pigeon&orientation=portrait',
    description: '台湾黑色动作片，通缉犯决心在自首前除掉两大恶人，暴力美学与人性探讨的完美融合。',
    fullDescription: '《周处除三害》是一部台湾黑色动作犯罪片，由黄精甫执导，阮经天主演。影片讲述了通缉犯陈桂林在得知自己身患绝症后，决定在自首之前为自己的生命留下意义。他发现自己在通缉榜上仅排名第三，于是决定除掉排名前两位的两大恶人——香港仔和牛头，以此实现"周处除三害"的古老典故。影片在激烈的黑帮火拼和动作场面之外，深刻探讨了罪与罚、救赎与人性的主题，以其独特的暴力美学和黑色幽默赢得了观众和评论界的一致好评。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文'],
    duration: '134分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['动作', '犯罪', '黑色'],
  },
  {
    id: '11',
    slug: 'qian-yu-qian-xun',
    title: '千与千寻',
    category: '动画片',
    categorySlug: 'donghua',
    rating: 9.4,
    year: 2001,
    image: 'https://readdy.ai/api/search-image?query=Spirited%20Away%20Studio%20Ghibli%20anime%20poster%2C%20magical%20bathhouse%20spirit%20world%2C%20Japanese%20animation%20masterpiece%2C%20mystical%20creatures%2C%20warm%20colorful%20palette%2C%20enchanting%20fantasy%20atmosphere%2C%20clean%20artistic%20poster&width=800&height=1200&seq=movie-spirited-away&orientation=portrait',
    description: '宫崎骏巅峰之作，少女千寻误入神灵世界后的奇幻冒险，荣获奥斯卡最佳动画长片。',
    fullDescription: '《千与千寻》是宫崎骏执导、吉卜力工作室制作的动画电影。影片讲述了十岁少女荻野千寻在搬家途中误入了一个神灵世界，她的父母因贪吃变成了猪，为了拯救父母并回到人间，千寻在汤婆婆经营的"油屋"浴场工作。在这个奇幻的世界里，她经历了各种奇遇，结识了白龙、无脸男、锅炉爷爷等角色，从一个胆小爱哭的小女孩逐渐成长为勇敢坚强的少女。影片以其丰富的想象力、精美的手绘画面和深刻的成长主题征服了全球观众，获得了奥斯卡最佳动画长片奖和柏林电影节金熊奖。',
    director: '宫崎骏',
    actors: ['柊瑠美', '入野自由', '夏木麻里'],
    duration: '125分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['动画', '奇幻', '经典'],
  },
  {
    id: '12',
    slug: 'jiao-yang-ban-wo',
    title: '骄阳伴我',
    category: '爱情片',
    categorySlug: 'aiqing',
    rating: 8.2,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=Sunshine%20By%20My%20Side%20Chinese%20romance%20drama%20poster%2C%20modern%20urban%20love%20story%2C%20warm%20sunlight%20city%20setting%2C%20romantic%20atmosphere%2C%20golden%20hour%20lighting%2C%20young%20couple%2C%20clean%20minimalist%20poster&width=800&height=1200&seq=movie-sunshine-by-my-side&orientation=portrait',
    description: '都市爱情剧，广告导演与新人设计师的甜蜜相遇，讲述了一段温暖治愈的姐弟恋故事。',
    fullDescription: '《骄阳伴我》是一部现代都市爱情剧，讲述了广告导演简冰和新人设计师盛阳之间的爱情故事。简冰是业内知名的广告导演，事业有成但感情生活一片空白。盛阳是一个刚刚毕业的年轻设计师，阳光开朗充满活力。两人因为一个广告项目意外相遇，从最初的专业合作逐渐发展出超越年龄差距的真挚感情。在追逐梦想的道路上，他们互相扶持、共同成长，用爱温暖了彼此的人生。',
    director: '宋晓飞',
    actors: ['肖战', '白百何', '田雨'],
    duration: '36集',
    type: 'series',
    isHot: false,
    isNew: true,
    tags: ['爱情', '都市', '治愈'],
  },
  {
    id: '13',
    slug: 'han-guo-ji-lu-pian-di-qiu',
    title: '地球脉动 第三季',
    category: '纪录片',
    categorySlug: 'jilupian',
    rating: 9.8,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=Planet%20Earth%20III%20BBC%20documentary%20poster%2C%20stunning%20wildlife%20photography%2C%20diverse%20ecosystems%2C%20majestic%20nature%20scenes%2C%20vibrant%20natural%20colors%2C%20award-winning%20nature%20cinematography%2C%20clean%20poster%20design&width=800&height=1200&seq=movie-planet-earth-3&orientation=portrait',
    description: 'BBC王牌纪录片系列最新力作，以超凡的摄影技术展现地球生命的壮丽与脆弱，每一帧都是壁纸。',
    fullDescription: '《地球脉动》第三季是BBC自然历史部出品的旗舰级自然纪录片，由大卫·爱登堡爵士担任旁白。本季历时五年拍摄完成，足迹遍布六大洲的43个国家和地区。从深海到高山，从沙漠到雨林，摄制组使用最先进的摄影技术捕捉到了前所未见的自然奇观和动物行为。影片不仅展现了大自然的壮美，也深刻揭示了气候变化对地球生态系统的深远影响，在令人叹为观止的视觉奇观中传递着保护地球的重要信息。',
    director: '尼克·伊斯顿',
    actors: ['大卫·爱登堡'],
    duration: '8集',
    type: 'series',
    isHot: false,
    isNew: true,
    tags: ['纪录片', '自然', 'BBC'],
  },
  {
    id: '14',
    slug: 'shu-shan-qi-xia-zhuan',
    title: '诛仙',
    category: '动作片',
    categorySlug: 'dongzuo',
    rating: 8.3,
    year: 2022,
    image: 'https://readdy.ai/api/search-image?query=Jade%20Dynasty%20Chinese%20fantasy%20martial%20arts%20poster%2C%20ancient%20Chinese%20immortal%20cultivation%20theme%2C%20sword%20fighting%20in%20misty%20mountains%2C%20mystical%20atmosphere%2C%20traditional%20Chinese%20aesthetic%2C%20ethereal%20lighting%2C%20clean%20poster&width=800&height=1200&seq=movie-jade-dynasty&orientation=portrait',
    description: '古典仙侠巨制，少年张小凡的修仙之路，身怀异宝卷入正邪纷争，特效精良的国产动画力作。',
    fullDescription: '《诛仙》根据萧鼎同名小说改编，是一部大型仙侠题材作品。故事围绕草庙村少年张小凡展开，他在一场灭村惨案后被青云门收为弟子。资质平平的他在机缘巧合下获得了"噬血珠"与"摄魂棒"两件绝世法宝，从此卷入了正邪两道的纷争之中。在修炼之路上，他结识了陆雪琪、碧瑶等好友，也遭遇了鬼王宗等强大对手。随着身世之谜逐渐揭开，张小凡发现灭村的真相远比想象中复杂。',
    director: '程小东',
    actors: ['李易峰', '赵丽颖', '杨紫'],
    duration: '52集',
    type: 'series',
    isHot: false,
    isNew: false,
    tags: ['仙侠', '古装', '动作'],
  },
  {
    id: '15',
    slug: 'zhao-ni-zhao-dao-zhen-xiang',
    title: '消失的她',
    category: '恐怖片',
    categorySlug: 'kongbu',
    rating: 8.4,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=Lost%20in%20the%20Stars%20Chinese%20suspense%20thriller%20poster%2C%20mysterious%20disappearance%20theme%2C%20tropical%20island%20setting%2C%20dark%20psychological%20atmosphere%2C%20intense%20dramatic%20lighting%2C%20crime%20mystery%20aesthetic%2C%20clean%20poster&width=800&height=1200&seq=movie-lost-in-the-stars&orientation=portrait',
    description: '悬疑惊悚片，妻子在海外旅行中离奇失踪，丈夫寻妻路上发现惊人真相，反转不断扣人心弦。',
    fullDescription: '《消失的她》是一部悬疑惊悚片，由崔睿、刘翔执导，朱一龙、倪妮主演。影片讲述了何非和妻子李木子前往东南亚某海岛旅行庆祝结婚周年，然而妻子在一天晚上神秘失踪。何非疯狂寻找妻子的下落，第二天早上却发现一个陌生女人躺在自己身边，声称自己就是他的妻子。所有的证件和照片都显示这个女人就是他失踪的妻子，但何非坚信这不是真的。在金牌律师陈麦的帮助下，何非踏上了一条充满危机和欺骗的寻找真相之路。',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    duration: '122分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['悬疑', '惊悚', '反转'],
  },
  {
    id: '16',
    slug: 'chang-an-san-wan-li',
    title: '长安三万里',
    category: '动画片',
    categorySlug: 'donghua',
    rating: 8.7,
    year: 2023,
    image: 'https://readdy.ai/api/search-image?query=Chang%20An%20Chinese%20animated%20movie%20poster%2C%20Tang%20Dynasty%20poetry%20theme%2C%20ancient%20Chinese%20capital%20city%2C%20traditional%20ink%20painting%20style%2C%20poetic%20atmosphere%2C%20golden%20and%20warm%20tones%2C%20historical%20Chinese%20aesthetic%2C%20clean%20poster&width=800&height=1200&seq=movie-changan&orientation=portrait',
    description: '追光动画十年力作，以李白和高适的友情为线索，再现盛唐气象，一部写给中国文化的浪漫情书。',
    fullDescription: '《长安三万里》是追光动画出品的动画电影，以唐代诗人高适的视角，回顾了他与李白跨越数十年的深厚友谊。影片从安史之乱后高适困守孤城展开，通过回忆片段呈现了两位诗人从青年到老年的传奇人生。影片中展现了长安城的繁华盛景、黄鹤楼的诗酒风流、扬州城的烟花三月，以及潼关、蓟北等历史名地的壮丽风光。48首经典唐诗贯穿全片，配合精美的国风画面，让观众在视觉盛宴中感受中国古典诗词的魅力。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    duration: '168分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['动画', '历史', '诗词'],
  },
];

export const featuredCollections = [
  {
    id: 'collection-1',
    title: 'IMDb TOP 250 精选',
    description: '全球影迷票选的最伟大电影合集',
    image: 'https://readdy.ai/api/search-image?query=Classic%20movie%20collection%20collage%20style%2C%20golden%20age%20of%20cinema%2C%20film%20reels%20and%20projector%2C%20warm%20vintage%20lighting%2C%20nostalgic%20atmosphere%2C%20cinema%20hall%20aesthetic&width=1200&height=600&seq=collection-imdb-top&orientation=landscape',
    movieIds: ['1', '2', '3', '9', '11'],
  },
  {
    id: 'collection-2',
    title: '国产科幻崛起之路',
    description: '从《流浪地球》到《三体》，见证中国科幻的力量',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20collection%20theme%2C%20futuristic%20technology%20visual%2C%20space%20exploration%2C%20cyberpunk%20Chinese%20city%2C%20cosmic%20nebula%20background%2C%20clean%20modern%20design&width=1200&height=600&seq=collection-chinese-scifi&orientation=landscape',
    movieIds: ['4', '7'],
  },
  {
    id: 'collection-3',
    title: '宫崎骏的奇幻世界',
    description: '走进动画大师构建的治愈童话',
    image: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20Movie%20collection%20theme%2C%20Japanese%20animation%20aesthetic%2C%20magical%20forest%20scene%2C%20soft%20pastel%20colors%2C%20whimsical%20fantasy%20atmosphere%2C%20hand-drawn%20animation%20style&width=1200&height=600&seq=collection-ghibli&orientation=landscape',
    movieIds: ['11'],
  },
];

export const faqData = [
  {
    question: '91精品视频在线播放提供哪些类型的影视内容？',
    answer: '我们涵盖了动作片、喜剧片、爱情片、科幻片、恐怖片、动画片、纪录片、剧情片等多种类型的影视资源。无论是好莱坞大片、国产佳作、日本动漫还是BBC纪录片，都能在这里找到精心筛选的推荐内容。',
  },
  {
    question: '网站上的影片资源如何更新？',
    answer: '我们的编辑团队每日更新精品推荐内容，紧跟最新上映和热门影视动态。您可以在首页的"最新上线"板块看到最近更新的影片，确保不错过任何一部好片。',
  },
  {
    question: '如何快速找到想看的电影？',
    answer: '您可以通过首页的分类导航栏按类型筛选影片，也可以使用搜索功能直接查找影片名称。每个分类页面都提供了该类型下的精选影片列表，方便您快速浏览。',
  },
  {
    question: '网站的画质和播放体验如何？',
    answer: '我们致力于为用户提供高清画质的影视内容推荐，所有推荐的资源均经过精心筛选，确保流畅的播放体验和优秀的画面质量。',
  },
  {
    question: '是否需要注册才能观看？',
    answer: '目前网站所有内容均可免费浏览，无需注册。您可以直接访问网站首页，浏览各类影视推荐内容，找到感兴趣的影片即可开始观看。',
  },
];

export const siteInfo = {
  name: '91精品视频在线播放',
  description: '精选高分电影和热门电视剧，助你告别片荒。每日更新精品推荐，全站高清画质流畅播放，必看影视一网打尽。',
  established: '2020年',
  email: 'contact@91jingpin.com',
  address: '中国北京市朝阳区',
};